import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { ConnectionSignalBar } from './types/classroom/interfaces'

import { ConnectionTier } from './types/classroom/enums'

interface ConnectionSignalGlyphOptions {
  tier: ComputedRef<ConnectionTier>
}

interface ConnectionSignalGlyphReturn {
  bars: ConnectionSignalBar[]
  refLitCount: ComputedRef<number>
  refIsLost: ComputedRef<boolean>
  refLabel: ComputedRef<string>
}

const BARS: ConnectionSignalBar[] = [
  { x: 0.6, y: 9, height: 5 },
  { x: 7.2, y: 5.2, height: 8.8 },
  { x: 13.8, y: 0.6, height: 13.4 },
]

const LIT_BAR_COUNT: Record<ConnectionTier, number> = {
  [ConnectionTier.Good]: 3,
  [ConnectionTier.Unstable]: 2,
  [ConnectionTier.Weak]: 1,
  [ConnectionTier.Lost]: 0,
}

const TIER_LABEL: Record<ConnectionTier, string> = {
  [ConnectionTier.Good]: 'Good connection',
  [ConnectionTier.Unstable]: 'Unstable connection',
  [ConnectionTier.Weak]: 'Weak connection',
  [ConnectionTier.Lost]: 'Connection lost',
}

export const useConnectionSignalGlyph = (
  options: ConnectionSignalGlyphOptions,
): ConnectionSignalGlyphReturn => ({
  bars: BARS,
  refLitCount: computed<number>(() => LIT_BAR_COUNT[options.tier.value]),
  refIsLost: computed<boolean>(() => options.tier.value === ConnectionTier.Lost),
  refLabel: computed<string>(() => TIER_LABEL[options.tier.value]),
})
